import { render, staticRenderFns } from "./AsnEdit.vue?vue&type=template&id=06fe825c"
import script from "./AsnEdit.vue?vue&type=script&lang=js"
export * from "./AsnEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports